export default __webpack_public_path__ + "static/media/Harness-1718803862348.af174093.png";